/*--------------------------------------------------------------
# Custom scripts for logoCarouselSlider block
--------------------------------------------------------------*/

const logoCarouselSliders = document.querySelectorAll('.logo-carousel-slider');

for ( let i = 0; i < logoCarouselSliders.length; i++ ) {
    const sliderWrapper = logoCarouselSliders[i];
    const swiperEl      = sliderWrapper.querySelector('.swiper');
    const nextEl        = sliderWrapper.querySelector('.logo-carousel-swiper-next');
    const prevEl        = sliderWrapper.querySelector('.logo-carousel-swiper-prev');

    // Add a unique index class so multiple instances don't cross-initialise.
    swiperEl.classList.add('swiper-' + i);
    nextEl.classList.add('logo-carousel-swiper-next-' + i);
    prevEl.classList.add('logo-carousel-swiper-prev-' + i);

    const initLogoCarouselSlider = new Swiper('.logo-carousel-slider:nth-of-type(' + (i + 1) + ') .swiper-' + i, {
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 24,
        navigation: {
            nextEl: '.logo-carousel-swiper-next-' + i,
            prevEl: '.logo-carousel-swiper-prev-' + i,
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            992: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
        },
    });
}
